import { render, staticRenderFns } from "./CreateVehiclePopup.vue?vue&type=template&id=38e1e2cf&"
import script from "./CreateVehiclePopup.vue?vue&type=script&lang=js&"
export * from "./CreateVehiclePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports